import Cookies from "js-cookie";
import reset from "./utils/reset_events.js";
class Dialog {
    constructor(element) {
        this.button = element;
        this.button_id = this.button.getAttribute("data-dialog");

        this.init();
    }

    init() {
        this.button.addEventListener("click", (e) => {
            this.current_id = e.currentTarget.dataset.dialog;
            this.current_dialog = document.getElementById(this.current_id);

            if (!this.current_dialog) return;

            this.open();

            this.current_dialog.addEventListener("click", (event) => {
                if (event.target.nodeName === "DIALOG") {
                    this.close();
                }
            });

            // Trigger close event functions if closed in anyway including esc key
            this.current_dialog.addEventListener("close", (event) => {
                this.unfixBody();
                this.stopVideo();
                this.current_dialog = null;
            });
        });

        const dialogHideElements = document.querySelectorAll(
            "[data-dialog-close]",
        );
        dialogHideElements.forEach((element) => {
            element.addEventListener("click", (e) => {
                this.current_dialog.close();
            });
        });

        this.setScrollbarWidth();

        if (this.button_id == "datepicker-dialog") {
            this.setDatepickerDialogOffset();
        }

        // this.openAnnouncement()
    }

    open() {
        if (this.current_id != "datepicker-dialog") this.fixBody();
        this.current_dialog.showModal();

        reset.refreshCarousels(this.current_dialog);
    }

    fixBody() {
        document.documentElement.classList.add("no-scroll");
    }

    unfixBody() {
        document.documentElement.classList.remove("no-scroll");
    }

    stopVideo() {
        const iframe = this.current_dialog
            ? this.current_dialog.querySelector("iframe")
            : null;
        if (iframe) iframe.src = iframe.src;
    }

    setScrollbarWidth() {
        // Use this to stop elements jumping when dialog is opened
        document.documentElement.style.setProperty(
            "--scrollbar-width",
            window.innerWidth - document.documentElement.clientWidth + "px",
        );
    }

    setDatepickerDialogOffset() {
        document.documentElement.style.setProperty(
            "--datepicker-document-offset",
            document.documentElement.scrollHeight + "px",
        );
        document.documentElement.style.setProperty(
            "--datepicker-btn-offset",
            this.button.getBoundingClientRect().top +
                this.button.offsetHeight +
                "px",
        );
    }

    openAnnouncement() {
        const announcementDialog =
            document.getElementById("announcementDialog");
        if (!announcementDialog) return;

        this.current_dialog = announcementDialog;

        setTimeout(() => {
            this.open();
            Cookies.set("viewed_announcement", true);
        }, timeout_length);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const dialogButtons = document.querySelectorAll("[data-dialog]");

    dialogButtons.forEach((element) => {
        new Dialog(element);
    });
});

export default Dialog;
